<template lang="pug">
  section.page.bg-alt
    b-container#privacyModal(size="lg", title="Privacy Policy", ok-only='')
      h1 Privacy Policy
      p.text-muted Effective date: December 04, 2020
      p.text-muted
        | WALL Co. ("us", "we", or "our") operates the https://www.wallcollective.co website (the "Service").
      p.text-muted
        | This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.
        //a(href='https://www.freeprivacypolicy.com/free-privacy-policy-generator.php') Free Privacy Policy Website
        | .
      p.text-muted
        | We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible from https://www.wallcollective.co
      h2 Information Collection And Use
      p.text-muted
        | We collect several different types of information for various purposes to provide and improve our Service to you.
      h3 Types of Data Collected
      h4 Personal Data
      p.text-muted
        | While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). Personally identifiable information may include, but is not limited to:
      ul
        li Email address
        li First name and last name
        li Address, State, Province, ZIP/Postal code, City
        li Cookies and Usage Data
      h4 Usage Data
      p.text-muted
        | We may also collect information how the Service is accessed and used ("Usage Data"). This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
      h4 Tracking & Cookies Data
      p.text-muted
        | We use cookies and similar tracking technologies to track the activity on our Service and hold certain information.
      p.text-muted
        | Cookies are files with small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Tracking technologies also used are beacons, tags, and scripts to collect and track information and to improve and analyze our Service.
      p.text-muted
        | You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.
      p.text-muted Examples of Cookies we use:
      ul
        li
          strong Session Cookies.
          |  We use Session Cookies to operate our Service.
        li
          strong Preference Cookies.
          |  We use Preference Cookies to remember your preferences and various settings.
        li
          strong Security Cookies.
          |  We use Security Cookies for security purposes.
      h2 Use of Data
      p.text-muted WALL Co. South Africa uses the collected data for various purposes:
      ul
        li To provide and maintain the Service
        li To notify you about changes to our Service
        li
          | To allow you to participate in interactive features of our Service when you choose to do so
        li To provide customer care and support
        li To provide analysis or valuable information so that we can improve the Service
        li To monitor the usage of the Service
        li To detect, prevent and address technical issues
      h2 Transfer Of Data
      p.text-muted
        | Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.
      p.text-muted
        | If you are located outside South Africa and choose to provide information to us, please note that we transfer the data, including Personal Data, to South Africa and process it there.
      p.text-muted
        | Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.
      p.text-muted
        | WALL Co. South Africa will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.
      h2 Disclosure Of Data
      h3 Legal Requirements
      p.text-muted
        | WALL Co. South Africa may disclose your Personal Data in the good faith belief that such action is necessary to:
      ul
        li To comply with a legal obligation
        li To protect and defend the rights or property of WALL Co. South Africa
        li To prevent or investigate possible wrongdoing in connection with the Service
        li To protect the personal safety of users of the Service or the public
        li To protect against legal liability
      h2 Security Of Data
      p.text-muted
        | The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
      h2 Service Providers
      p.text-muted
        | We may employ third party companies and individuals to facilitate our Service ("Service Providers"), to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used.
      p.text-muted
        | These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
      h3 Analytics
      p.text-muted
        | We may use third-party Service Providers to monitor and analyze the use of our Service.
      ul
        li
          p
            strong Google Analytics
          p.text-muted
            | Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data collected to track and monitor the use of our Service. This data is shared with other Google services. Google may use the collected data to contextualize and personalize the ads of its own advertising network.
          p.text-muted
            | You can opt-out of having made your activity on the Service available to Google Analytics by installing the Google Analytics opt-out browser add-on. The add-on prevents the Google Analytics JavaScript (ga.js, analytics.js, and dc.js) from sharing information with Google Analytics about visits activity.
          p.text-muted
            | For more information on the privacy practices of Google, please visit the Google Privacy & Terms web page:
            a(href='https://policies.google.com/privacy?hl=en') https://policies.google.com/privacy?hl=en
      h2 Links To Other Sites
      p.text-muted
        | Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.
      p.text-muted
        | We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.
      h2 Children's Privacy
      p.text-muted Our Service does not address anyone under the age of 18 ("Children").
      p.text-muted
        | We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your Children has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers.
      h2 Changes To This Privacy Policy
      p.text-muted
        | We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
      p.text-muted
        | We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update the "effective date" at the top of this Privacy Policy.
      p.text-muted
        | You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
      h2 Contact Us
      p.text-muted If you have any questions about this Privacy Policy, please contact us:
      ul
        li By email: info@wallcollective.co
  </template>

<script>
export default {
  name: 'Privacy',
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Terms.vue